/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state máº·c Ä‘á»‹nh cá»§a module
 */
import commonFunc from '@/common/commonFunction';

export default {
	updateAllTreeOrganizations(state, res) {
		state.AllTreeOrganizations.removeAll();
		if (res && res.length > 0) {
			state.AllTreeOrganizations = [...res];
		}
	},
	updateAllOrganizations(state, res) {
		state.AllOrganizations.removeAll();
		if (res && res.length > 0) {
			state.AllOrganizations = [...res];
		}
	},
	updateOrganizationsUnit(state, res) {
		state.OrganizationUnits.removeAll();
		if (res && res.length > 0) {
			state.OrganizationUnits = [...res];
			if (state.OrganizationWorking) {
				let working = state.OrganizationUnits.find(x => x.Id == state.OrganizationWorking.Id);
				if (working != undefined && working != null) {
					state.OrganizationWorking.InvoiceCount = working.InvoiceCount;
					state.OrganizationWorking.OutInvoiceCount = working.OutInvoiceCount;
					state.OrganizationWorking.DeclarationCount = working.DeclarationCount;
				}
			}
		}
	},
	updateOrganizations(state, res) {
		state.Organizations.removeAll();
		if (res && res.length > 0) {
			state.Organizations = [...res];
		}
	},
	updateOrganizationWorking(state, res) {
		//Cáº­p nháº­t láº¡i Ä‘Æ¡n vá»‹ Ä‘ang lÃ m viá»‡c
		let org = commonFunc.getOrgWorkingUpdate(state.OrganizationUnits, res);
		state.OrganizationWorking = org;
		//Cáº­p nháº­t láº¡i Ä‘Æ¡n vá»‹ lÃ m viá»‡c
		let newOrganizations = [...state.OrganizationUnits];
		state.OrganizationUnits = newOrganizations;
	},

	updateEmailReceiveOrgWorking(state, res) {
		if (state.OrganizationWorking) {
			state.OrganizationWorking.InvRevEmail = res;
		}
	},

	updateSubscriberWorking(state, res) {
		state.SubscriberWorking = res;
	},
	activeOrganizationGuide(state, res) {
		state.organizationGuide = res;
	},
	increaseInvoiceCount(state, orgId) {
		let org = commonFunc.getOrgWorkingUpdate(state.OrganizationUnits, { Id: orgId });
		if (org) {
			org.InvoiceCount++;
			//Cáº­p nháº­t láº¡i sá»‘ lÆ°á»£ng báº£n ghi Ä‘ang cÃ³ cá»§a Chi nhÃ¡nh phÃ²ng ban
			if (state.OrganizationWorking && state.OrganizationWorking.Id == org.Id) {
				state.OrganizationWorking = Object.assign({}, state.OrganizationWorking, {
					InvoiceCount: org.InvoiceCount
				});
			}
		}
	},

	increaseOutInvoiceCount(state, orgId) {
		let org = commonFunc.getOrgWorkingUpdate(state.OrganizationUnits, { Id: orgId });
		if (org) {
			org.OutInvoiceCount++;
			//Cáº­p nháº­t láº¡i sá»‘ lÆ°á»£ng báº£n ghi Ä‘ang cÃ³ cá»§a Chi nhÃ¡nh phÃ²ng ban
			if (state.OrganizationWorking && state.OrganizationWorking.Id == org.Id) {
				state.OrganizationWorking = Object.assign({}, state.OrganizationWorking, {
					OutInvoiceCount: org.OutInvoiceCount
				});
			}
		}
	},
	/**
	 * TÄƒng sá»‘ tá» khai theo chi nhÃ¡nh
	 * @author dqduy 06.02.2024
	 * @param {*} state
	 * @param {*} orgId
	 */
	increaseDeclarationCount(state, orgId) {
		let org = commonFunc.getOrgWorkingUpdate(state.OrganizationUnits, { Id: orgId });
		if (org) {
			org.DeclarationCount++;
			//Cáº­p nháº­t láº¡i sá»‘ lÆ°á»£ng báº£n ghi Ä‘ang cÃ³ cá»§a Chi nhÃ¡nh phÃ²ng ban
			if (state.OrganizationWorking && state.OrganizationWorking.Id == org.Id) {
				state.OrganizationWorking = Object.assign({}, state.OrganizationWorking, {
					DeclarationCount: org.DeclarationCount
				});
			}
		}
	},

	updateHiddenTip(state, res) {
		state.hiddenTips = true;
	},
	// getOrganization(state, res){
	//     state.Organization = res;
	// },
	// updateOriganization(state, res){
	//     state.Organization = res;
	// }
	updateTourGuide(state, res) {
		//Náº¿u chi nhÃ¡nh chÆ°a cÃ³ hÃ³a Ä‘Æ¡n nÃ o, khi cÃ³ hÃ³a Ä‘Æ¡n má»›i Ä‘Æ°á»£c thÃªm thÃ¬ cáº¯m cá» hiá»ƒn thá»‹ hÆ°á»›ng dáº«n
		if (!state.viewTourGuide && state.OrganizationWorking.InvoiceCount == 1) {
			state.viewTourGuide = true;
		}
	},

	changeViewTourGuide(state, res) {
		state.viewTourGuide = res;
	},

	updateShowPaymentWarnings(state, res) {
		state.ShowPaymentWarnings.push(res);
	},

	/**
	 * Cáº­p nháº­t cÃ¡c chi nhÃ¡nh phÃ²ng ban Ä‘Ã£ thá»±c hiá»‡n show thÃ´ng bÃ¡o (Ä‘Ã£ thá»±c hiá»‡n káº¿t ná»‘i CQT thuáº¿ rá»“i)
	 */
	updateShowConnectTaxaxions(state, res) {
		state.ShowConnectTaxaxions.push(res);
	},

	updateConnectTax(state, val) {
		state.IsShowConnectTax = val;
	},

	updateShowLostConnectTaxaxion(state, res) {
		state.ShowLostConnectTaxaxion.push(res);
	},

	updateLostConnectTaxaxion(state, val) {
		state.IsShowLostConnectTaxaxion = val;
	},

	updateInvoiceRiskBySupplier(state, val) {
		state.IsShowInvoiceRiskBySupplier = val;
	},

	updateFullTreeOrganizations(state, res) {
		state.FullTreeOrganizations.removeAll();
		if (res && res.length > 0) {
			state.FullTreeOrganizations = [...res];
		}
	},

	/**
	 * Cáº­p nháº­t thÃ´ng tin CCCD cho cÃ¡c tá»• chá»©c trong cache
	 * @param {Object} state - Vuex state
	 * @param {Object} payload - Dá»¯ liá»‡u cáº­p nháº­t
	 * @param {Array} payload.organizations - Danh sÃ¡ch tá»• chá»©c Ä‘Ã£ cáº­p nháº­t (orgSelecteds)
	 * @param {string} payload.identificationNumber - Sá»‘ CCCD má»›i
	 */
	updateOrganizationIdentificationInCache(state, payload) {
		const { organizations, identificationNumber } = payload;

		// Validation
		if (!organizations || !Array.isArray(organizations)) {
			return;
		}

		if (!identificationNumber || identificationNumber.trim() === '') {
			return;
		}

		// Táº¡o Set chá»©a cÃ¡c Id cáº§n cáº­p nháº­t Ä‘á»ƒ tá»‘i Æ°u performance
		const orgIdsToUpdate = commonFunc.cloneDeepData(organizations.map(org => org.Id));
		const checkExistOrg = (orgId, orgIdsToUpdate) => {
			const checkOrg = orgIdsToUpdate.find(id => id == orgId);
			return checkOrg ? true : false;
		};

		// Function Ä‘á»ƒ cáº­p nháº­t dá»¯ liá»‡u org
		const updateOrgData = org => {
			if (!org) return;
			org.IdentificationNumber = identificationNumber;
			org.IsBusinessHousehold = true;
		};

		const updateAllOrgs = (orgs, orgIdsToUpdate) => {
			if (!orgs || !Array.isArray(orgs) || orgs.length <= 0 || !orgIdsToUpdate || orgIdsToUpdate.length <= 0) {
				return;
			}

			orgs.forEach(org => {
				const checkOrg = checkExistOrg(org.Id, orgIdsToUpdate);
				if (checkOrg) {
					updateOrgData(org);
				}
			});
		};

		// 1.1. Update OrganizationUnits (danh sÃ¡ch phÃ²ng ban chá»n nhanh - flat)
		if (state.OrganizationUnits && Array.isArray(state.OrganizationUnits)) {
			updateAllOrgs(state.OrganizationUnits, orgIdsToUpdate);
		}

		// 1.2. Update AllOrganizations (táº¥t cáº£ danh sÃ¡ch phÃ²ng ban dáº¡ng flat)
		if (state.AllOrganizations && Array.isArray(state.AllOrganizations)) {
			updateAllOrgs(state.AllOrganizations, orgIdsToUpdate);
		}

		// 1.3. Update OrganizationWorking (Ä‘Æ¡n vá»‹ Ä‘ang lÃ m viá»‡c - single object)
		if (state.OrganizationWorking && orgIdsToUpdate.find(id => id == state.OrganizationWorking.Id)) {
			updateOrgData(state.OrganizationWorking);
		}

		// ===== 2. Cáº¬P NHáº¬T TREE DATA =====
		// Function Ä‘á»‡ quy Ä‘á»ƒ tÃ¬m vÃ  cáº­p nháº­t trong tree
		const updateInTreeStructure = (treeData, cacheName) => {
			const findAndUpdateInTree = (nodes, level = 1) => {
				if (!nodes || !Array.isArray(nodes)) return;

				nodes.forEach(node => {
					// Kiá»ƒm tra node hiá»‡n táº¡i
					if (checkExistOrg(node.Id, orgIdsToUpdate)) {
						updateOrgData(node);
					}

					// Äá»‡ quy vÃ o Childrens (tá»‘i Ä‘a 3 cáº¥p)
					if (level < 3 && node.Childrens && Array.isArray(node.Childrens) && node.Childrens.length > 0) {
						findAndUpdateInTree(node.Childrens, level + 1);
					}
				});
			};

			findAndUpdateInTree(treeData);
		};

		// 2.1. Update AllTreeOrganizations (dáº¡ng tree cho combo export, lá»c auditlogs)
		if (state.AllTreeOrganizations && Array.isArray(state.AllTreeOrganizations)) {
			updateInTreeStructure(state.AllTreeOrganizations, 'AllTreeOrganizations');
		}

		// 2.2. Update FullTreeOrganizations (cÆ¡ cáº¥u tá»• chá»©c khÃ´ng cáº§n quyá»n)
		if (state.FullTreeOrganizations && Array.isArray(state.FullTreeOrganizations)) {
			updateInTreeStructure(state.FullTreeOrganizations, 'FullTreeOrganizations');
		}

		// 2.3. Update Organizations (danh sÃ¡ch phÃ²ng ban trong cÆ¡ cáº¥u tá»• chá»©c)
		if (state.Organizations && Array.isArray(state.Organizations)) {
			updateInTreeStructure(state.Organizations, 'Organizations');
		}
	}
};
